import { fetchExpiredInventories, selectInventory, resetCurrentInventory } from '../../actions/inventories_actions';
import { connect } from 'react-redux';

import InventoryExpired from '../../components/Inventories/inventoryExpired'

function mapStateToProps(state) {
    return {
        inventories: state.inventories.expiredInventories,
        isLoading: state.inventories.expiredIsLoading,
        error: state.inventories.expiredError,
        currentInventory: state.inventories.currentInventory
    };
}

export default connect(mapStateToProps, { fetchExpiredInventories, selectInventory, resetCurrentInventory })(InventoryExpired);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryExpired.jsx